import { render, staticRenderFns } from "./PhrasesRow.vue?vue&type=template&id=7f044d68&scoped=true"
import script from "./PhrasesRow.vue?vue&type=script&lang=js"
export * from "./PhrasesRow.vue?vue&type=script&lang=js"
import style0 from "./PhrasesRow.vue?vue&type=style&index=0&id=7f044d68&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f044d68",
  null
  
)

export default component.exports